<template>
    <div class="page-list" v-if="employee">
        <div class="page-title">
            <div class="page-back" @click="$router.go(-1)">
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                    <path fill="currentColor" d="M10.05 16.94V12.94H18.97L19 10.93H10.05V6.94L5.05 11.94Z"/>
                </svg>
            </div>
          Сказать СПАСИБО
        </div>
        <div class="page-subtitle" style="text-align: left">
            Выберите, кого благодарить
        </div>
        <input style="margin-bottom: 24px; font-size: 16px" class="card" v-model="searchRequest" placeholder="Поиск по ФИО, должности или филиалу"/>
        <div class="page-subtitle" style="text-align: center;" v-if="employee.length === 0">
          <b style="color: tomato"> Вы можете сказать еще {{ count }} СПАСИБО в этом месяце </b>
        </div>
        <EmployerComponent :employee="it" v-for="(it, index) in employee" :key="index"
                           @click="openEmployee(it.id)"/>
    </div>
</template>

<script>
import EmployerComponent from "./components/EmployerComonent.vue";

export default {
    name: 'EmployeePage',
    components: {EmployerComponent},
    data: function() {
        return {
            searchRequest: ''
        }
    },
  metaInfo() {
    return {
      title: 'СПАСИБО',
      meta: [
        {name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0'}
      ]
    }
  },
    computed: {
      profile() {
        return this.$store.getters.profile
      },
        employee() {
            return this.$store.getters.employee.filter(it => {
                return this.searchRequest.length > 0 && (
                    it.name.toLowerCase().indexOf(this.searchRequest.toLowerCase()) > -1 ||
                    it.position.toLowerCase().indexOf(this.searchRequest.toLowerCase()) > -1 ||
                    it.department.toLowerCase().indexOf(this.searchRequest.toLowerCase()) > -1)
            })
        },
      thanks() {
        return this.$store.getters.from
      },
      count() {
        if (this.profile && [794286672, 11098895180, 15064562551].indexOf(this.profile.id) > -1) {
          return 999
        } else {
          return 3 - this.thanks.filter(it => new Date(it.date).getMonth() === new Date().getMonth() && new Date(it.date).getFullYear() === new Date().getFullYear()).length
        }
      }
    },
    methods: {
        openEmployee(id) {
            this.$store.commit('selectEmployee', id)
            this.$router.push('/employer')
        }
    }
}
</script>
